import { Action, Dispatch } from 'redux'
import { closeModalAction } from 'reducks/modal/actions'

const closeModal = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(closeModalAction())
  }
}

export default closeModal
